export enum EnrollmentStatusEnum {
    PENDING = 0,
    COMPLETE = 1,
    CANCELLED = 2,
    EXPIRED = 3,
    UNKNOWN = 4,
}
